export enum ProgramType {
  BATTCM = 'BAT-TCM',
  FTOTCM = 'FTO-TCM',
  BAT = 'BAT'
}
